import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import { getAthleteData } from "store/actions/AvRatingAction";
import { deleteAthleteWithIndex } from "store/actions/AvRatingAction";
import { clearAthleteData } from "store/actions/AvRatingAction";
import { addRvRatingData } from "store/actions/AvRatingAction";
import {
  fetchSchoolStates,
  getSchoolCounty,
  getCollegeCity,
  fetchStates,
} from "store/actions/athleteActions";
import { newCollegeUniversities } from "store/actions/newCollegeUniversities";
import { newSchoolsData } from "store/actions/newSchoolsAction";

const AvRating = () => {
  let dispatch = useDispatch();
  let history = useHistory();
  const [contractLevel, setContractLevel] = useState("College athlete");
  const [state, setState] = useState("");
  const [college, setCollege] = useState("");
  const [newSchool, setNewSchool] = useState("");
  const [officialName, setOfficialName] = useState("");
  const [officialIdDocument, setOfficialIdDocument] = useState(null);
  const [officialRole, setOfficialRole] = useState("");
  const [officialEmail, setOfficialEmail] = useState("");
  const [rows, setRows] = useState([{ athleteId: "", rvRating: "" }]);
  const [loader, setLoader] = useState(false);

  const handleAddRow = () => {
    setRows([...rows, { athleteId: "", rvRating: "" }]);
  };
  const addAthlete = (id, index) => {
    const data = {
      state,
      college,
      newSchool,
      contractLevel,
    };
    if (state && college && newSchool && contractLevel && id) {
      dispatch(getAthleteData(id, data, index));
    } else {
      toast.warning("Please fill add data");
    }
  };

  const handleRowChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;
    setRows(newRows);
  };

  const handleRemoveRow = (index) => {
    dispatch(deleteAthleteWithIndex(index));
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
  };

  const handleFileChange = (e) => {
    setOfficialIdDocument(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const officialData = {
      state,
      college,
      newSchool,
      officialName,
      officialIdDocument,
      officialRole,
      officialEmail,
      rows,
    };

    if (
      rows.some((row) => row.rvRating === "") ||
      rows.some((row) => row.rvRating == 0)
    ) {
      toast.error("add rating");
    } else {
      setLoader(true);
      dispatch(
        addRvRatingData(officialData, () => {
          setRows([{ athleteId: "", rvRating: "" }]);
          setOfficialEmail("");
          setOfficialRole("");
          setOfficialIdDocument(null);
          setOfficialName("");
          setNewSchool("");
          setCollege("");
          setState("");
          setContractLevel("College athlete");
          dispatch(clearAthleteData());
          setLoader(false);
          history.push("/home");
        })
      );
    }
  };

  const { states, schoolStates, counties, cities } = useSelector(
    (state) => state.athlete
  );
  const { athleteData } = useSelector((state) => state.officialData);
  const { newSchoolsAllData } = useSelector((state) => state.schools);
  const { newCollegeUniversitiesData } = useSelector(
    (state) => state.collegeAndUniversities
  );

  useEffect(() => {
    if (state !== "" && college !== "") {
      if (contractLevel === "College athlete") {
        dispatch(newCollegeUniversities(state, college));
      } else {
        dispatch(newSchoolsData(state, college));
      }
    }
  }, [state, college]);

  useEffect(() => {
    dispatch(fetchStates());
    dispatch(fetchSchoolStates());
  }, []);

  useEffect(() => {
    if (state !== "") {
      if (contractLevel === "College athlete") {
        dispatch(getCollegeCity(state));
      } else {
        dispatch(getSchoolCounty(state));
      }
    }
  }, [state]);

  let newSchools = [];

  const getInstitutes = () => {
    if (contractLevel === "College athlete") {
      newCollegeUniversitiesData?.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          if (ele !== "OTHER") {
            newSchools.push(ele);
          }
        });
      });
    } else {
      newSchoolsAllData.forEach((insti) => {
        insti.institutes?.forEach((ele) => {
          if (ele !== "OTHER") {
            newSchools.push(ele);
          }
        });
      });
    }
    return newSchools;
  };

  const defaultNewSchoolProps = {
    options: getInstitutes(),
    getOptionLabel: (option) => option,
  };
  const defaultCollegeProps = {
    options:
      contractLevel === "College athlete"
        ? [...(cities?.map((insti) => insti.city) ?? [])]
        : [...(counties?.map((insti) => insti.county) ?? [])],
    getOptionLabel: (option) => option,
  };
  const defaultStateProps = {
    options:
      contractLevel === "College athlete"
        ? states?.map((insti) => insti.name)
        : schoolStates?.map((insti) => insti.name),
    getOptionLabel: (option) => option,
  };

  return (
    <>
      <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
        <IoMdArrowBack /> Go Back
      </button>
      <div className="text-center">
        <a
          href="https://youtu.be/E2qeqMHQ1I8"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://youtu.be/E2qeqMHQ1I8
        </a>
      </div>
      {/* 
      <Container>
        <Form onSubmit={handleSubmit}>
          <Label className="mt-3 auth-label">
            Click for College or High School
          </Label>
          <div className="d-flex ml-4 mt-2 mb-4">
            <div>
              <Input
                type="radio"
                checked={contractLevel === "College athlete"}
                id="d_yes"
                name="contractLevel"
                value="College athlete"
                onChange={(e) => {
                  setContractLevel(e.target.value);
                  setState("");
                  setCollege("");
                  setNewSchool("");
                }}
              />
              <Label
                for="d_yes"
                className={`auth-label ${
                  contractLevel === "College athlete" ? "text-primary" : ""
                }`}
              >
                College
              </Label>
            </div>
            <div className="mx-auto">
              <Input
                type="radio"
                id="d_no"
                name="contractLevel"
                checked={contractLevel === "High School athlete"}
                value="High School athlete"
                onChange={(e) => {
                  setContractLevel(e.target.value);
                  setState("");
                  setCollege("");
                  setNewSchool("");
                }}
              />
              <Label
                for="d_no"
                className={`auth-label ${
                  contractLevel === "High School athlete" ? "text-primary" : ""
                }`}
              >
                High School
              </Label>
            </div>
          </div>

          <Label className="mt-2 auth-label">
            Address Where
            {contractLevel === "College athlete" ? " College" : " School"}{" "}
            Located
          </Label>
          <br />
          <div className="d-sm-flex">
            <div className="col-sm-4">
              <Label className="auth-label mt-3">State</Label>
              <Autocomplete
                {...defaultStateProps}
                id="auto-complete"
                autoComplete
                includeInputInList
                value={state}
                onChange={(e, val) => {
                  setState(val);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="State"
                    variant="standard"
                  />
                )}
              />
            </div>
            <div className="col-sm-4">
              <Label className="auth-label mt-3">
                {contractLevel === "College athlete" ? "City" : "County"}
              </Label>
              <Autocomplete
                {...defaultCollegeProps}
                id="auto-complete-college"
                autoComplete
                includeInputInList
                disabled={!state}
                value={college}
                onChange={(e, val) => {
                  if (val === "OTHER") {
                    setCollege(val);
                    setNewSchool("OTHER");
                  } else {
                    setCollege(val);
                    setNewSchool("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      contractLevel === "College athlete" ? "City" : "County"
                    }
                    variant="standard"
                  />
                )}
              />
            </div>
            <div className="col-sm-4">
              <Label className="auth-label mt-3">School</Label>
              <Autocomplete
                {...defaultNewSchoolProps}
                id="auto-complete-school"
                autoComplete
                includeInputInList
                value={newSchool}
                disabled={!state || !college}
                onChange={(e, val) => setNewSchool(val)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select your School from Dropdown menu"
                    variant="standard"
                  />
                )}
              />
            </div>
          </div>
          <Row className="mt-4">
            <Col md={4}>
              <Label className="auth-label">Official Name</Label>
              <Input
                required
                type="text"
                placeholder="Add name"
                value={officialName}
                onChange={(e) => setOfficialName(e.target.value)}
              />
            </Col>
            <Col md={4}>
              <Label className="auth-label">Official Id-Document</Label>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                required
                style={{ display: "none" }}
              />
              <div>
                <label htmlFor="fileInput" className="custom-file-input2">
                  Choose file
                </label>
              </div>
              {officialIdDocument && (
                <p>Selected file: {officialIdDocument.name}</p>
              )}
            </Col>
            <Col md={4}>
              <Label className="auth-label">Official Role</Label>
              <Input
                type="text"
                placeholder="Add role"
                value={officialRole}
                onChange={(e) => setOfficialRole(e.target.value)}
                required
              />
            </Col>
            <Col md={4}>
              <Label className="auth-label">Official Email</Label>
              <Input
                type="email"
                placeholder="Add email"
                value={officialEmail}
                onChange={(e) => setOfficialEmail(e.target.value)}
                required
              />
            </Col>
          </Row>
          {rows.map((row, index) => (
            <Row className="mt-4 reapeatingRow" key={index}>
              <Col md={4}>
                <Label className="auth-label">Athlete Id</Label>
                <Input
                  type="number"
                  placeholder="Add athlete ID"
                  value={row.athleteId}
                  onChange={(e) =>
                    handleRowChange(index, "athleteId", e.target.value)
                  }
                  required
                />
              </Col>
              <Col md={4}>
                <Label className="auth-label">Total RV Rating</Label>
                <Input
                  type="number"
                  placeholder="Add RV Rating"
                  value={row.rvRating}
                  disabled={athleteData.length == index}
                  onChange={(e) =>
                    handleRowChange(index, "rvRating", Number(e.target.value))
                  }
                  max={1.99}
                  required
                />
              </Col>

              <Col lg="4">
                <div>
                  {rows.length > 1 && (
                    <Button
                      color="danger"
                      className="AddRemContainer"
                      onClick={() => handleRemoveRow(index)}
                    >
                      -
                    </Button>
                  )}
                  {index === rows.length - 1 && athleteData.length != index && (
                    <Button
                      color="primary"
                      className="AddRemContainer"
                      onClick={handleAddRow}
                    >
                      +
                    </Button>
                  )}
                  <Button
                    onClick={() => addAthlete(rows[index]?.athleteId, index)}
                    color="primary"
                    className="AddRemContainer"
                  >
                    Add
                  </Button>
                </div>
              </Col>
              <Table className="align-items-center table-flush mt-3" responsive>
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      Email
                    </th>
                    <th
                      scope="col"
                      className="custom-table-heading custom-heading"
                    >
                      ID
                    </th>
                  </tr>
                </thead>
                <tbody className="mt-3">
                  {athleteData.length >= index && (
                    <tr>
                      <td className="custom-table-text">
                        {athleteData[index]?.first_name}
                      </td>
                      <td className="custom-table-text">
                        {athleteData[index]?.email}
                      </td>
                      <td className="custom-table-text">
                        {athleteData[index]?.athleteID}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          ))}

          <Col md={12} className="mt-4">
            <Button color="primary" type="submit" disabled={loader}>
              {loader ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </Col>
        </Form>
      </Container> */}
    </>
  );
};

export default AvRating;
